import { render, staticRenderFns } from "./PeiXunEnrollManager.vue?vue&type=template&id=47f39ca9"
import script from "./PeiXunEnrollManager.vue?vue&type=script&lang=js"
export * from "./PeiXunEnrollManager.vue?vue&type=script&lang=js"
import style0 from "./PeiXunEnrollManager.vue?vue&type=style&index=0&id=47f39ca9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports